import { Link } from 'react-router-dom';

const handleWhatsAppClick = () => {
  if (typeof (window as Window & { gtag?: (...args: unknown[]) => void }).gtag === 'function') {
    (window as Window & { gtag: (...args: unknown[]) => void }).gtag('event', 'conversion', {
      send_to: 'AW-17106059641/wLJKCOOCiIscEPmC59w_',
      value: 1.0,
      currency: 'CLP',
    });
  }
};

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const footerLinks = {
    servicios: [
      { name: 'Redacción de contratos', path: '/servicios' },
      { name: 'Revisión de contratos', path: '/servicios' },
      { name: 'Constitución de empresas', path: '/servicios' },
      { name: 'Registro de marca', path: '/servicios' },
      { name: 'Trámites empresariales', path: '/servicios' },
    ],
    empresa: [
      { name: 'Sobre nosotros', path: '/sobre-nosotros' },
      { name: 'Cómo funciona', path: '/como-funciona' },
      { name: 'Contacto', path: '/contacto' },
    ],
    legal: [
      { name: 'Términos y condiciones', path: '#' },
      { name: 'Política de privacidad', path: '#' },
      { name: 'Política de cookies', path: '#' },
    ],
    soporte: [
      { name: 'Preguntas frecuentes', path: '#' },
      { name: 'WhatsApp', path: 'https://wa.me/56912345678' },
      { name: 'Email', path: 'mailto:contacto@balacorp.cl' },
    ],
  };

  return (
    <footer className="bg-primary-black text-white pt-20 pb-10">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        {/* Top Section - 4 Columns */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-16">
          {/* Servicios */}
          <div>
            <h4 className="text-primary-yellow text-sm font-bold uppercase mb-4">
              Servicios
            </h4>
            <div className="w-10 h-0.5 bg-primary-yellow mb-6"></div>
            <ul className="space-y-3">
              {footerLinks.servicios.map((link, index) => (
                <li key={index}>
                  <Link
                    to={link.path}
                    className="text-white hover:text-primary-yellow transition-colors duration-200 text-sm cursor-pointer"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Empresa */}
          <div>
            <h4 className="text-primary-yellow text-sm font-bold uppercase mb-4">
              Empresa
            </h4>
            <div className="w-10 h-0.5 bg-primary-yellow mb-6"></div>
            <ul className="space-y-3">
              {footerLinks.empresa.map((link, index) => (
                <li key={index}>
                  <Link
                    to={link.path}
                    className="text-white hover:text-primary-yellow transition-colors duration-200 text-sm cursor-pointer"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h4 className="text-primary-yellow text-sm font-bold uppercase mb-4">
              Legal
            </h4>
            <div className="w-10 h-0.5 bg-primary-yellow mb-6"></div>
            <ul className="space-y-3">
              {footerLinks.legal.map((link, index) => (
                <li key={index}>
                  <a
                    href={link.path}
                    className="text-white hover:text-primary-yellow transition-colors duration-200 text-sm cursor-pointer"
                  >
                    {link.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Soporte */}
          <div>
            <h4 className="text-primary-yellow text-sm font-bold uppercase mb-4">
              Soporte
            </h4>
            <div className="w-10 h-0.5 bg-primary-yellow mb-6"></div>
            <ul className="space-y-3">
              {footerLinks.soporte.map((link, index) => (
                <li key={index}>
                  <a
                    href={link.path}
                    target={link.path.startsWith('http') ? '_blank' : '_self'}
                    rel={link.path.startsWith('http') ? 'nofollow noopener noreferrer' : ''}
                    onClick={link.name === 'WhatsApp' ? handleWhatsAppClick : undefined}
                    className="text-white hover:text-primary-yellow transition-colors duration-200 text-sm cursor-pointer"
                  >
                    {link.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Bottom Section */}
        <div className="border-t border-gray-800 pt-12">
          <div className="flex flex-col lg:flex-row justify-between items-center space-y-8 lg:space-y-0">
            {/* Left - Logo & Tagline */}
            <div className="text-center lg:text-left">
              <img 
                src="https://public.readdy.ai/ai/img_res/c4157c16-ad0a-4d50-9c4d-5c82b9d7b146.png" 
                alt="Bala Corp" 
                className="h-14 w-auto object-contain mx-auto lg:mx-0 mb-4"
              />
              <div className="w-32 h-0.5 bg-primary-yellow mx-auto lg:mx-0 mb-3"></div>
              <p className="text-gray-400 text-sm">
                Simplificando servicios legales en Chile
              </p>
            </div>

            {/* Right - Copyright & Social */}
            <div className="text-center lg:text-right">
              <p className="text-gray-400 text-xs mb-4">
                © {currentYear} Bala Corp. Todos los derechos reservados.
              </p>
              <div className="flex items-center justify-center lg:justify-end space-x-4">
                <a
                  href="https://linkedin.com"
                  target="_blank"
                  rel="nofollow noopener noreferrer"
                  className="w-10 h-10 flex items-center justify-center rounded-full border-2 border-primary-yellow text-primary-yellow hover:bg-primary-yellow hover:text-black transition-all duration-300 cursor-pointer"
                  aria-label="LinkedIn"
                >
                  <i className="ri-linkedin-fill text-lg"></i>
                </a>
                <a
                  href="https://instagram.com"
                  target="_blank"
                  rel="nofollow noopener noreferrer"
                  className="w-10 h-10 flex items-center justify-center rounded-full border-2 border-primary-yellow text-primary-yellow hover:bg-primary-yellow hover:text-black transition-all duration-300 cursor-pointer"
                  aria-label="Instagram"
                >
                  <i className="ri-instagram-fill text-lg"></i>
                </a>
                <a
                  href="https://twitter.com"
                  target="_blank"
                  rel="nofollow noopener noreferrer"
                  className="w-10 h-10 flex items-center justify-center rounded-full border-2 border-primary-yellow text-primary-yellow hover:bg-primary-yellow hover:text-black transition-all duration-300 cursor-pointer"
                  aria-label="Twitter"
                >
                  <i className="ri-twitter-x-fill text-lg"></i>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;